module.exports = __webpack_public_path__ + "img/data_overview_title.d60268fa.png";